import { useEffect } from "react";

import AddIcon from "@mui/icons-material/Add";
import clsx from "clsx";
import { useSession } from "next-auth/react";
import { useAudioRecorder } from "react-audio-voice-recorder";

import { useRequireAuthContext } from "@musicfy/libs/RequireAuthProvider";

const AudioRecorder: React.FC<{
  onRecordingComplete: (file: File) => void;
}> = ({ onRecordingComplete }) => {
  const { showAuthModal } = useRequireAuthContext();
  const { status } = useSession();
  const recorderControls = useAudioRecorder();

  useEffect(() => {
    if (
      !!recorderControls &&
      recorderControls.recordingBlob !== null &&
      recorderControls.recordingBlob !== undefined
    ) {
      const file = new File([recorderControls.recordingBlob], "recording.mp3", {
        type: "audio/mp3",
      });

      onRecordingComplete(file);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recorderControls.recordingBlob]);

  return (
    <div
      aria-label={
        recorderControls.isRecording ? "Stop Recording" : "Record Audio"
      }
      className="w-full bg-white/5 cursor-pointer rounded-12 border border-white border-opacity-20 group py-6 px-12"
      onClick={() => {
        if (status === "unauthenticated") {
          showAuthModal();
          return;
        }
        if (!recorderControls.isRecording) {
          recorderControls.startRecording();
        } else {
          recorderControls.stopRecording();
        }
      }}
    >
      <div className="flex justify-between w-full items-center">
        <div className="flex flex-col w-full flex-1">
          <div
            className="text-white text-sm font-light capitalize"
            aria-label=""
          >
            Or
          </div>
          <div className="text-white text-[26px] font-semibold" aria-label="">
            {recorderControls.isRecording ? "Stop Recording" : "Record Audio"}
          </div>
        </div>
        <div
          className={clsx(
            "w-12 h-12 border-white border-2 flex items-center justify-center rounded-full"
          )}
        >
          <div
            className={clsx("bg-[#FF5151] bg-opacity-80", {
              "animate-pulse rounded-[2px] w-5 h-5":
                recorderControls.isRecording,
              "rounded-full w-7 h-7": !recorderControls.isRecording,
            })}
          >
            &nbsp;
          </div>
        </div>
      </div>
      <div className="h-px w-full mt-6 mb-4 bg-white/20" />
      <div className="w-12 h-12 flex items-center justify-center text-pink-200 rounded-4 border border-white/20 bg-gray-1000/20">
        <AddIcon />
      </div>
    </div>
  );
};

export default AudioRecorder;
